import Badge from "components/v2/Badge/Badge";
import { getFreightModeIcon } from "helpers/freightModeHelper";

interface QuotationFreightModeBadgeProps {
  quotation: any;
}

export default function QuotationFreightModeBadge({ quotation }: QuotationFreightModeBadgeProps) {
  const { service } = quotation;
  const { freight_mode_label, freight_mode_type, road_freight_type } = service;

  const Icon = getFreightModeIcon(freight_mode_label, freight_mode_type, true);
  const label = road_freight_type ? `${freight_mode_label} - ${road_freight_type.toUpperCase()}` : freight_mode_label;

  return (
    <Badge label={label} color="gray" type="category-badge" variant="icon-leading" icon={<Icon height={16} width={16} />} />
  );
}
